/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  window.addEventListener('theme:variant:change', e => {
    const { target, detail: { variant }} = e

    if (!target.hasAttribute('data-quick-add-modal')) return;
    if (!target.querySelector('.js-email-input')) return;

    target.querySelector('.product-form').classList.remove('has-success')

    target.querySelector('.js-email-input')?.classList[variant.available ? 'add': 'remove']('hidden')
    target.querySelector('.js-atc-btn')?.classList[variant.available ? 'remove': 'add']('hidden')
    target.querySelector('.js-subscribe-btn')?.classList[variant.available ? 'add': 'remove']('hidden')

    if (variant.available) {
      target.querySelector('.js-email-input').setAttribute('disabled', '')
    } else {
      target.querySelector('.js-email-input').removeAttribute('disabled')
    }
  })
  document.addEventListener('click', e => {
    const button = e.target.closest('.js-subscribe-btn')
    if (!button) return;
    e.preventDefault();

    const form = e.target.closest('form')
    const emailInput = form.querySelector('.js-email-input')
    const formData = new FormData(form)
    const id = formData.get('id')
    const email = formData.get('email')
    const emailError = form.querySelector('.email-error');
    const msg = document.querySelector('.product__notification__message')

    for(var pair of formData.entries()){
      console.log(pair[0], pair[1]);
    }
    emailInput.classList.remove('error')
    emailError.style.display = 'none'
    msg.style.display = 'none'


    if (!validateEmail(email)) {
      emailInput.classList.add('error')
      emailError.style.display = 'block'
      return
    }

    button.classList.add('is-loading');

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          },
          channels: [
            'EMAIL'
          ]
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${id}`
            }
          }
        }
      }
    }

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${ window.theme.settings.klaviyoCompanyId }`, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2024-10-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.text())
    .then(() => {
      emailInput.value = ''
      form.classList.add('has-success')
      msg.style.display = 'block'

    })
    .catch(err => console.error(err))
    .finally(() => {
      button.classList.remove('is-loading');

      setTimeout(() => {
        form.classList.remove('has-success')
        msg.style.display = 'none'
      }, 3000)
    });
  })
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


document.addEventListener('DOMContentLoaded', () => {
  const mobileMenu = document.querySelector('#header-menu')
  const accordionItems = mobileMenu.querySelectorAll('.accordion-item')

  accordionItems.forEach(accordionItem => {
    accordionItem.addEventListener('click', e => {
      if(e.target.classList.contains('accordion-item-link')) return
      e.preventDefault()
      e.stopPropagation();
      e.stopImmediatePropagation();

      accordionItem.classList.toggle('is-open')
    })
    })




// document.addEventListener("theme:cart:change", ()=> didcountNinjaCall() )

})

const moneyFormat = "${{amount}}"

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "")
  }
  let value = ""
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || moneyFormat

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split(".")
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`)
    const centsAmount = parts[1] ? decimal + parts[1] : ""

    return dollarsAmount + centsAmount
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2)
      break
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0)
      break
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",")
      break
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",")
      break
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".")
      break
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", "")
      break
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",")
      break
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".")
      break
  }

  return formatString.replace(placeholderRegex, value)
}





(function() {
  const backCartBtn = document.querySelector('.cart__button-continue .btn');
  if(!Boolean(backCartBtn)) return
  const continueShoppingText = document.querySelector('.continue-shopping-text');
  const backButtonText = document.querySelectorAll('.back-shopping-text');
  const lastPageUrl = document.referrer;
  let url = sessionStorage.getItem("lastVisitedUrl");
  console.log(Boolean(url))

  if(Boolean(lastPageUrl)) {
    sessionStorage.setItem("lastVisitedUrl", lastPageUrl);
    url = sessionStorage.getItem("lastVisitedUrl");
  }

  if(Boolean(url)) {
    backCartBtn.href=url
    backButtonText.forEach(btn => {
      btn.style.display = 'flex'
    })
    continueShoppingText.style.display = 'none';

  } else {
    continueShoppingText.style.display = 'block';
    backButtonText.forEach(btn => {
      btn.style.display = 'none'
    })
  }

})()